import { axios } from '@Root/API'

export const edit = (id, data) => {
	return axios.put(`update/moodle-link/${id}`, data)
}
